// @ts-check

import { expenses } from '@/core/constants'

export const purchaseTypeOptions = Object.values(expenses).map((expense) => ({
  value: expense
}))

export const incomeTypeSales = 'sales'

export const businessRelatedOptions = [{ value: true }, { value: false }]

export const incomeRegionEU = 'eu'

export const incomeCountryOptions = Object.freeze([
  { value: 'finland' },
  { value: incomeRegionEU },
  { value: 'other' }
])

export const buyFromCountryOptions = Object.freeze([
  { value: 'finland' },
  { value: 'eu' },
  { value: 'other' }
])
